<!--
 * @Description: 忘记密码， 这是个响应式的页面
 * @Autor: lwq
 * @Date: 2020-08-17 17:30:59
 * @LastEditors: betwaym 848032671@qq.com
 * @LastEditTime: 2024-01-30 17:48:20
 * @FilePath: \web_admin\src\views\reset-password\index.vue
-->
<template>
  <div class="forget-password">
    <!-- 背景 -->
    <!-- <div class="bgd_right_box"
         style="position:absolute;">
      <mrc_ess_svgIcon iconClass="right"
                       class="bgd_one bgd_right_box_img" />
    </div>

    <div class="bgd_left_box"
         style="position:absolute;">
      <mrc_ess_svgIcon iconClass="left"
                       class="bgd_two bgd_left_box_img" />
    </div> -->
    <mrc_ess_svgIcon iconClass="left" class="left_bg"
      :style="{ left: -bgstyle / 2 + 'px', width: bgstyle + 'px', height: bgstyle + 'px' }" />
    <mrc_ess_svgIcon iconClass="right" class="right_bg"
      :style="{ right: -bgstyle / 2 + 'px', width: bgstyle + 'px', height: bgstyle + 'px' }" />
    <!-- webPc 的页面 -->
    <div class="webPc" v-if="webPc">
      <!-- 重置密码 -->
      <v-card class="webResetPassword" elevation="24">
        <div class="forgot_title text-h3">{{ $t(title) }}</div>
        <mrc_ess_input :placeholder="$t('label_newpassword')" background-color="#fff" style="margin-top: 16px"
          @input="$v.savePwdParams.user_pwd.$touch()" @blur="$v.savePwdParams.user_pwd.$touch()"
          @keyupEnter="!loading && savePwdHandler()" v-model.trim="savePwdParams.user_pwd" :append-icon="icon"
          :type="type" @click:append="showPassword" :error-messages="$errors(
            'savePwdParams',
            'user_pwd',
            requiredRule.concat({
              rule: 'passwordStrengthRegxRule',
              msg: regxMsg,
            })
          )
            "></mrc_ess_input>
        <mrc_ess_input @keyupEnter="!loading && savePwdHandler()" :placeholder="$t('label_Retypepassword')"
          background-color="#fff" @input="$v.savePwdParams.sameAsPassword.$touch()"
          @blur="$v.savePwdParams.sameAsPassword.$touch()" :append-icon="icon" :type="type" @click:append="showPassword"
          v-model.trim="savePwdParams.sameAsPassword" :error-messages="$errors(
            'savePwdParams',
            'sameAsPassword',
            requiredRule.concat(sameAsKey($t('label_password')))
          )
            "></mrc_ess_input>

        <mrc_ess_submitBtn backgroundColor="#fff" class="mt-8" :successBackgroundColor="successBackgroundColor"
          :disabled="disabled" :loading="loading" @success="savePwdHandler" @cancel="backHandler"></mrc_ess_submitBtn>
      </v-card>
    </div>

    <!-- 这是手机的输入框 -->
    <div class="phoneH5" v-else>
      <!-- 重置密码 -->
      <v-card class="resetPassword" elevation="24">
        <div class="forgot_title">{{ $t(title) }}</div>
        <mrc_ess_input placeholder="new password" background-color="#fff" style="margin-top: 16px"
          @input="$v.savePwdParams.user_pwd.$touch()" @blur="$v.savePwdParams.user_pwd.$touch()"
          v-model.trim="savePwdParams.user_pwd" :type="type" :append-icon="icon" @click:append="showPassword"
          :error-messages="$errors(
            'savePwdParams',
            'user_pwd',
            requiredRule.concat({
              rule: 'passwordStrengthRegxRule',
              msg: regxMsg,
            })
          )
            "></mrc_ess_input>
        <mrc_ess_input placeholder="Retype password" background-color="#fff"
          @input="$v.savePwdParams.sameAsPassword.$touch()" @blur="$v.savePwdParams.sameAsPassword.$touch()"
          :append-icon="icon" :type="type" @click:append="showPassword" v-model.trim="savePwdParams.sameAsPassword"
          :error-messages="$errors(
            'savePwdParams',
            'sameAsPassword',
            requiredRule.concat(sameAsKey($t('label_password')))
          )
            "></mrc_ess_input>
        <!-- class="flex-column-reverse phoneSubmitBtn" -->
        <mrc_ess_submitBtn backgroundColor="#fff" :loading="loading" :successBackgroundColor="successBackgroundColor"
          :disabled="disabled" class="phoneSubmitBtn mt-8" @success="savePwdHandler" @cancel="backHandler">
        </mrc_ess_submitBtn>
      </v-card>
    </div>
    <!-- 这是页面底部的版本信息 -->
    <div class="bottom">
      <p>
        © {{ new Date().getFullYear() }} MRC International Group Limited. All
        rights reserved
        <a href="https://privacy.essencehr.io/" target="_blank" class="hover1"
          style="color:#ffffff;text-decoration: none;caret-color: #fff!important;">Privacy Policy</a>
        and
        <a href="https://terms.essencehr.io/" target="_blank" class="hover2"
          style="color:#ffffff;text-decoration: none;caret-color: #fff!important;">Term of Use.</a>
      </p>
    </div>
    <!-- <div class="bottom">
      <p class="ft3 mb-0">
        © {{ new Date().getFullYear() }} MRC International Group Limited. All
        rights reserved
      </p>
      <p class="ma-0">
        <a href="https://privacy.essencehr.io/"
           target="_blank"
           style="color:#FFFFFF;text-decoration: none">Privacy Policy</a>
        and
        <a href="https://terms.essencehr.io/"
           target="_blank"
           style="color:#FFFFFF;text-decoration: none">Term of Use.</a>
      </p>
    </div> -->
    <v-overlay :value="overlay" z-index="99">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators"
import {
  savePwd,
  sendEmail,
  checkToken,
  passwordStrength,
} from "@/service/api/forgot-password"

import Cookie from "js-cookie"
export default {
  components: {},
  props: {},
  data() {
    return {
      overlay: false,
      pubk: "",
      regxMsg: "",
      regxRule: "",
      disabled: false,
      successBackgroundColor: "primary",
      urlParams: {},
      title: "label_To_reset_your_password",
      icon: "mdi-eye-off",
      type: "password",
      sendMail: false,

      sendEmailParams: {
        user_account: "",
      },
      savePwdParams: {
        user_account: "",
        user_pwd: "",
        sameAsPassword: "",
        token: "",
      },
      openDialog: false,
      is_showPassword: false,
      screenSize: "",
      // 是web的尺寸 true  手机的尺寸 false
      webPc: true,
      loading: false,
    }
  },
  validations: {
    // sendEmailParams: {
    //   user_account: {
    //     required,
    //   },
    // },
    savePwdParams: {
      user_pwd: {
        required,
        passwordStrengthRegxRule(val) {
          return new RegExp(this.regxRule).test(val)
        },
      },
      sameAsPassword: {
        required,
        sameAsKey(val) {
          return val && val == this.savePwdParams.user_pwd
        },
      },
    },
  },
  computed: {
    bgstyle() {
      let size = 0;
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          size = 0;
          break;
        case "sm":
          size = 600;
          break;
        case "md":
          size = 900;

          break;
        case "lg":
          size = 1000;

        case "xl":
          size = 1200;

          break;
        default:
          break;
      }
      return size;
    },
  },
  watch: {},
  async mounted() {
    this.overlay = true
    try {
      this.$ls.clear()
      this.$store.dispatch("resetState")

      this.getQueryParams()
      await this.$store.dispatch("set_languageList")
      this.$store.commit("set_lang", {
        text: "",
        value: this.urlParams.language
          ? this.urlParams.language
          : this.$store.state.lang,
      })
      // 判断是发送邮件还是重置密码
      this.$i18n.mergeLocaleMessage(
        this.urlParams.language,
        this.$store.state.languageList[this.urlParams.language]
      )
      this.pubk = await this.$store.dispatch("setPubk")

      this.overlay = false
      if (this.urlParams.token) {
        this.successBackgroundColor = "#e0e0e0"
        this.disabled = true
        const res = await checkToken({
          token: this.urlParams.token,
          // user_account: this.urlParams.user_account,
          // user_account: this.$encrypt({
          //   msg: this.urlParams.user_account,
          //   // key: 123,
          //   key: this.$store.getters.pubk,
          // }),
        })
        if (res.code == 200) {
          this.getPasswordStrength()
          this.savePwdParams.token = res.token
          this.$store.dispatch("set_token", { token: res.token })
          this.$ls.set("refresh-token", res["refresh-token"])
          this.savePwdParams.user_account = this.urlParams.user_account
          this.sendMail = false
          // this.title = 'Reset Password'
          this.disabled = false
          this.successBackgroundColor = "primary"
        } else {
          setTimeout(() => {
            if (this.urlParams.login_url) {
              // window.location.href = this.urlParams.login_url
            } else {
              this.$Message({
                text: this.$t("message_linkExpired"),
                color: "rgba(0, 0, 0, 0.78)",
              })
            }
          }, 5000)
          this.sendMail = true
        }
      } else {
        this.successBackgroundColor = "#e0e0e0"
        this.disabled = true
        setTimeout(() => {
          if (this.urlParams.login_url) {
            // window.location.href = this.urlParams.login_url
          } else {
            this.$Message({
              text: this.$t("message_linkExpired"),
              color: "rgba(0, 0, 0, 0.78)",
            })
          }
        }, 2000)
      }
      const that = this
      that.screenSize = document.documentElement.clientWidth
      if (that.screenSize > 750) {
        that.webPc = true
      } else {
        that.webPc = false
      }
      this.resize(function () {
        that.screenSize = document.documentElement.clientWidth
        if (that.screenSize > 750) {
          that.webPc = true
        } else {
          that.webPc = false
        }
      })
    } catch (err) {
      this.overlay = false
    }
  },

  methods: {
    // 获取密码强度验证
    async getPasswordStrength() {
      const res = await passwordStrength({
        // user_account: this.urlParams.user_account,
        // user_account: this.$encrypt({
        //   msg: this.urlParams.user_account,
        //   key: this.$store.getters.pubk,
        // }),
      })
      if (res.code == 200) {
        this.regxMsg = res.data.ceckmean
        this.regxRule = res.data.cecknum
      }
    },
    // 获取url参数
    getQueryParams() {
      let params = {}
      let href = this.$route.params.token
      if (href) {
        href = "?token=" + href

        const search = new URLSearchParams(href)
        params.token = search.get("token")
        // params.user_account = search.get("user_account")
        params.login_url = search.get("login_url")
        params.language = search.get("language")
        this.urlParams = params
      } else {
        this.urlParams = {}
      }
    },
    showPassword() {
      this.is_showPassword = !this.is_showPassword
      if (this.is_showPassword) {
        this.icon = "mdi-eye"
        this.type = "text"
      } else {
        this.icon = "mdi-eye-off"
        this.type = "password"
      }
    },
    // back
    backHandler() {
      if (this.urlParams.login_url) {
        window.location.href = this.urlParams.login_url
      } else {
      }
    },
    // 修改密码
    async savePwdHandler() {
      this.$v.savePwdParams.$touch()
      if (this.$v.savePwdParams.$error) return
      this.loading = true
      const res = await savePwd({
        // token: this.savePwdParams.token,
        // user_account: this.$encrypt({
        //   msg: this.savePwdParams.user_account,
        //   // key: 123,
        //   key: this.$store.getters.pubk,
        // }),
        user_pwd: this.$encrypt({
          msg: this.savePwdParams.user_pwd,
          // key: 123,
          key: this.$store.getters.pubk,
        }),
        url: window.location.host,
      })
      if (res.code == 200) {
        this.$store.commit(
          "newsTips",
          this.$t("message_The_modification_was_successful")
        )
        setTimeout(() => {
          if (this.urlParams.login_url) {
            window.location.href = this.urlParams.login_url
          } else {
            this.$store.commit(
              "newsTips",
              this.$t("message_resetPasswordThenbackTologin")
            )
          }
        }, 500)
      }
      this.loading = false
    },

    resize(fn) {
      window.addEventListener("resize", function () {
        fn()
      })
    },
  },
}
</script>

<style scoped>
@import '../login/bgd.css';

.forget-password {
  width: 100%;
  height: 100%;
  position: relative;
  /* background: url('../../assets/img/loginBg.png') no-repeat; */
  text-align: center;
  background-color: #0f46c1;
}

.webResetPassword,
.webSendMail {
  width: 480px;
  height: 334px;
  border-radius: 4px;
  background: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 0 32px;
}

.webSendMail {
  height: 334px;
}

.webPc .forgot_title {
  margin-top: 32px;
  text-align: left;
  font-size: 28px;
}

.forget-password /deep/ .btnGroup {
  justify-content: flex-end;
  /* height: 48px; */
  height: 32px;
}

.forget-password /deep/ .successBtn {
  /* width: 170px; */
  height: 32px;
  max-height: 48px !important;
  margin-left: 14px;
}

.forget-password /deep/ .cencelBtn {
  font-weight: medium;
  margin-right: 0;
}

.phoneH5 .sendMail,
.phoneH5 .resetPassword {
  height: 449px;
  border-radius: 4px;
  background: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 0 32px;
  width: 343px;
}

.phoneH5 .sendMail,
.phoneH5 .resetPassword {
  min-width: 300px;
}

.phoneH5 .resetPassword {
  height: 350px;
}

.phoneH5 .forgot_title {
  margin-top: 38px;
  text-align: left;
  font-size: 28px;
}

.phoneH5 .phoneSubmitBtn /deep/ .successBtn {
  margin: 20px 0;
}

.bottom {
  width: 100%;
  position: absolute;
  bottom: 5px;
  text-align: center;
  left: 50%;
  z-index: 10;
  color: rgba(255, 255, 255, 0.68);
  /* color: black; */
  transform: translateX(-50%);
  font-family: var(--body-font-family) !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 12px !important;
  line-height: 128.91% !important;
}

.bottom p {
  letter-spacing: 1px;
  margin: 0;
}

/deep/ .v-size--small {
  padding: 0 24px;
}

/* @-webkit-keyframes bgd_rotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes bgd_rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.bgd_left_box {
  transform: translate(-42%, 20%);
}
.bgd_right_box {
  transform: translate(40%, -57%);
}
.bgd_left_box_img {
  width: calc(64rem * 2);
  height: calc(68rem * 2);
  animation: bgd_rotate 20s ease-in-out infinite;
}
.bgd_right_box_img {
  width: calc(58rem * 4);
  height: calc(68rem * 4);
  animation: bgd_rotate 20s ease-in-out infinite;
}
@media screen and (max-width: 2000px) {
  .bgd_left_box {
    transform: translate(-42%, 20%);
  }
  .bgd_right_box {
    transform: translate(54%, -53%);
  }
  .bgd_left_box_img {
    width: calc(64rem);
    height: calc(68rem);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
  .bgd_right_box_img {
    width: calc(58rem * 2);
    height: calc(68rem * 2);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
}

@media screen and (max-width: 1400px) {
  .bgd_left_box {
    transform: translate(-55%, 16%);
  }
  .bgd_left_box_img {
    width: calc(64rem * 0.9);
    height: calc(68rem * 0.9);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
  .bgd_right_box {
    transform: translate(54%, -32%);
  }
  .bgd_right_box_img {
    width: calc(58rem * 1.5);
    height: calc(68rem * 1.5);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
}

@media screen and (max-width: 992px) {
  .bgd_left_box {
    transform: translate(-68%, 22%);
  }
  .bgd_left_box_img {
    width: calc(64rem * 0.8);
    height: calc(68rem * 0.8);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
  .bgd_right_box {
    transform: translate(46%, -31%);
  }
  .bgd_right_box_img {
    width: calc(58rem * 1.5);
    height: calc(68rem * 1.5);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
}
@media screen and (max-width: 800px) {
  .bgd_left_box {
    display: none;
  }
  .bgd_right_box {
    display: none;
  }
} */
</style>
